import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.18 1.5C8.007 1.5 4 4.579 4 9.487c0 1.145.357 2.39.853 3.59.503 1.218 1.188 2.481 1.931 3.687a49.3 49.3 0 0 0 4.452 6.056 1.25 1.25 0 0 0 1.89-.005c1.15-1.336 2.96-3.574 4.49-5.973.764-1.2 1.474-2.463 1.997-3.692.516-1.213.887-2.48.887-3.663 0-5.126-4.424-7.987-8.32-7.987m.07 10.875a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: r };
export {
  i as default,
  r as render
};
//# sourceMappingURL=ic_location_filled-2KrGt3MS.js.map
